import { DefaultTheme } from '../theme';

export const CSS = {
	container: 'c-Table',
	title: 'c-Table__Title',
	header: 'c-Table__Header',
	body: 'c-Table__Body',
	row: 'c-Table__row',
	cell: 'c-Table__cell',
	MDL: {
		table: 'mdl-data-table',
		cell: 'mdl-data-table__cell--non-numeric',
	},
};

const TITLE_HEIGHT = DefaultTheme.space(12);

export const Style = {
	[CSS.container]: {
		'box-shadow': DefaultTheme.shadow.box.dp2,
		margin: DefaultTheme.space(4),
	},
	[CSS.title]: {
		display: 'flex',
		'justify-content': 'space-between',
		height: TITLE_HEIGHT,
		'line-height': TITLE_HEIGHT,
		padding: `0 ${DefaultTheme.space(6)}`,
		'& h6': {
			margin: 0,
			'line-height': TITLE_HEIGHT,
		},
	},
	[`${CSS.header} th`]: {
		'font-weight': DefaultTheme.font.weight.normal,
	},
	[CSS.body]: {
		width: '100%',
		border: 0,
		'background-color': 'transparent',
		'table-layout': 'fixed',
		'& td:first-of-type, & th:first-of-type': {
			width: '100px',
		},
	},
	[CSS.cell]: {
		'max-width': '100%',
		'text-overflow': 'ellipsis',
		'white-space': 'nowrap',
		overflow: 'hidden',
	},
};
